<script lang="ts" setup>
  import { StoreLayout, AccountLayout } from '@storefront/components';

  defineOptions({
    layout: [StoreLayout, AccountLayout],
    inheritAttrs: false,
  });

  defineProps({
    offer: { type: Object, required: true },
    quotation: { type: Object, required: true },
  });
</script>
<template>
  <AccountMobileNavigation :href="$route('web.account.offers.show', { offer: offer.id })">
    {{ $t('SHOP.ACCOUNT.HEADER.SALE_OFFER_QUOTATION_NUMBER', { number: quotation.number }) }}
  </AccountMobileNavigation>
  <OfferQuotationView :offer="offer" :quotation="quotation" />

  <RouterView />
</template>
